module.exports = __webpack_public_path__ + "img/8599fd32cda76beabcd5e795c49df7f9.png";